import { Dispatch, Action } from 'redux'
import { BillingMainMapDispatchReturnType } from './types/BillingMainMapDispatchReturnType'

export const BillingMainMapDispatch = (
  _dispatch: Dispatch<Action>
): BillingMainMapDispatchReturnType => {
  return {}
}
